import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"download\"><path d=\"M12.172 1a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 18 6.828V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h8.172Zm0 1H4a1 1 0 0 0-.993.883L3 3v14a1 1 0 0 0 .883.993L4 18h12a1 1 0 0 0 .993-.883L17 17V6.828a1 1 0 0 0-.206-.608l-.087-.099-3.828-3.828a1 1 0 0 0-.576-.284L12.172 2ZM10 6v6.929L11.687 11H13l-3.5 4L6 11h1.312L9 12.929V6h1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol